import { AuthenticatedService } from "..";
import { ILogRepository, SystemLogInformation } from "../../domain/system";
import { ISystemLogMessageBean } from "./beans";

export class LogRepository  extends AuthenticatedService implements ILogRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  public async addSystemLog(info: SystemLogInformation): Promise<void> {
    const url = "api/log/system-logs";
    const data: ISystemLogMessageBean = {
      level: info.level,
      patientId: info.patientId,
      message: info.message,
    };
    await this.post(url, data);
  }
}
